import React, { useEffect, useState } from 'react';
import Logo from './../assets/images/logo_auth.png';
import LogoLogin from './../assets/images/informasi-harga.png';
import { ClipLoader } from 'react-spinners';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import * as Yup from 'yup';
import { API } from '../api/api';
import { useLocation } from 'react-router-dom';
import { registerFailed, registerSuccess, setUserProp, visitRegisterPage } from '../services/amplitude';
import LogoWithDesc from '../components/LogoWithDesc';
import CaptchaCheckbox from '../components/CaptchaCheckbox';
import FormRegister from '../components/FormRegister';
import TNCLink from '../components/TNCLink';
import FormRegisterAction from '../components/FormRegister/Action';
import axios from 'axios';
import MainBox from '../components/MainBox';
import Grid from '@mui/material/Grid2';
import ActionLoginSocial from '../components/ActionLoginSocial';
import BoxInfoSuccess from '../components/BoxInfoSuccess';
import { useFormik } from 'formik';

const Register = () => {
  const { state } = useLocation();

  const [success, setSuccess] = useState(false);
  const [passwordScore, setPasswordScore] = useState({
    password: 0,
    passwordConfirm: 0,
  });
  const [captchaUnverified, setCaptchaUnverified] = useState(true);

  const MySwal = withReactContent(Swal);

  const formik = useFormik({
    isInitialValid: false,
    initialValues: {
      first_name: '',
      email: '',
      password: '',
      password_confirm: '',
    },
    validateOnChange: true,
    validationSchema: Yup.object({
      first_name: Yup.string()
        .required("Nama wajib diisi")
        .min(4, 'Nama tidak boleh kosong dengan minimal 4 karakter.')
        .max(50)
        .matches(/^[A-Za-z\s]+$/, 'Hanya boleh mengandung alfabet dan spasi.').test('no-trailing-space', 'Nama tidak diboleh diakhiri spasi', value => !value?.endsWith(' ')),
      email: Yup.string()
        .min(3)
        .email()
        .matches(
          /^[^-?[\]\\|()*^~`]+$/,
          "Email tidak boleh mengandung: - ? [ ] | \\ / ( ) * ^ ~ `"
        )
        .max(100)
        .required(),
      password: Yup.string().required().min(6),
      password_confirm: Yup.string().required().min(6).oneOf([Yup.ref('password'), null], 'kata sandi tidak sesuai,coba lagi!')
    }),
    onSubmit: async (values) => {

      try {
        const res = await axios.post(
          API.register,
          {
            name: formik.values.first_name,
            email: formik.values.email,
            password: formik.values.password,
          },
          {
            headers: {
              Platform: 'map',
            },
          }
        );

        if (res.status !== 201) {
          throw res;
        }

        const { status, message } = res.data;

        MySwal.fire({
          title: status === 0 ? 'Pendaftaran Gagal' : 'Pendaftaran Berhasil',
          icon: status === 0 ? 'error' : 'success',
          text: status === 0 ? message : 'Cek Email Anda untuk verifikasi Akun',
        });

        setSuccess(status !== 0);

        if (status !== 0) {
          registerSuccess(formik.values.email, formik.values.first_name, 'email');
          setUserProp({
            email: formik.values.email,
            name: formik.values.first_name,
            is_User: 'False',
            is_Premium: 'False',
          });
        } else {
          registerFailed(message, formik.values.email, 'email');
        }
      } catch (err) {
        const data = err.response && err.response.data;
        const message = data && data.message;

        if (err?.data?.status === 0) {
          registerFailed(err.message, formik.values.email, 'email');

          MySwal.fire({
            title: 'Error',
            icon: 'error',
            text: err.data.message,
          });
        }

        if (message) {
          registerFailed(message, formik.values.email, 'email');

          if (data.data.email && data.data.email.length > 0) {
            formik.setFieldError('email', Array.from(data.data.email).toString())
          }
          if (data.data.name && data.data.name.length > 0) {
            formik.setFieldError('first_name', Array.from(data.data.name).toString())
          }
          if (data.data.password && data.data.password.length > 0) {
            formik.setFieldError('password', Array.from(data.data.password).toString())

          }

          MySwal.fire({
            title: 'Pesan',
            icon: 'error',
            text: message,
          });
        }
      }
    }
  })

  const isFormValid = formik.isValid && passwordScore.password >= 2 && !captchaUnverified

  useEffect(() => {
    state && visitRegisterPage(state.pageChannel);
  }, []);

  return (
    <>
      <div className="page">
        <MainBox>
          <Grid container>
            <Grid size={{
              lg: 8,
              md: 12,
            }}>
              <LogoWithDesc
                logo={Logo}
                title="Market Auction Price"
                desc={
                  <>
                    Market Auction Price (MAP) adalah aplikasi yang <br></br>
                    menyediakan informasi harga pasaran mobil lelang<br></br>
                    terlengkap di Indonesia. Buatlah keputusan yang tepat
                    <br></br> dan menguntungkan, karena semua informasi harga
                    <br></br>pasaran mobil yang mau Anda beli atau jual ada disini.
                  </>
                }
              />
            </Grid>
            <Grid size={{
              lg: 4,
              md: 12
            }} sx={{
              padding: '1.5rem 2rem'
            }}>
              {!formik.isSubmitting ? (
                !success ? (
                  <form onSubmit={formik.handleSubmit}>
                    <div className="form-group form-register bg-white rounded py-2 px-4">
                      <h4 className="mb-4 mt-2">Daftar</h4>
                      <FormRegister
                        isTouched={formik.touched}
                        errors={formik.errors}
                        formOnChange={(event) => {
                          // onChange(event);
                          formik.handleChange(event)
                        }}
                        values={formik.values}
                        setPasswordScore={setPasswordScore}
                      />

                      <CaptchaCheckbox
                        onChange={(value) => setCaptchaUnverified(value === null)}
                        sitekey={process.env.REACT_APP_RECAPTCHA_KEY}
                      />
                      <TNCLink />

                      <FormRegisterAction disabled={!isFormValid} isLoading={formik.isSubmitting} />

                      <ActionLoginSocial onClick={() => {
                        formik.setSubmitting(true)
                      }} />
                    </div>
                  </form>
                ) : <BoxInfoSuccess title='Pendaftaran Berhasil' subtitle='Cek Email Anda untuk Verifikasi Akun' />
              ) : (
                <div className="form-group form-login bg-white rounded d-flex justify-content-center align-items-center  py-5 h-100">
                  <ClipLoader loading size={100} />
                </div>
              )}
            </Grid>
          </Grid>
        </MainBox>
      </div>
      <div className="page-mobile">
        <div className="container-fluid">
          <div className="row d-flex justify-content-center pt-5" style={{ backgroundColor: '#f0f0f0' }}>
            <img style={{ width: '80%', height: '60%' }} src={LogoLogin} alt="Market Auction Price" />
          </div>
          <div className="row pt-3">
            <form onSubmit={formik.handleSubmit}>
              <div className="col-12 mt-2">
                <h4 className="mb-4">Daftar</h4>
                <FormRegister
                  isTouched={formik.touched}
                  errors={formik.errors}
                  formOnChange={(event) => {
                    formik.handleChange(event)
                  }}
                  values={formik.values}
                  setPasswordScore={setPasswordScore}
                />

                <CaptchaCheckbox
                  onChange={(value) => setCaptchaUnverified(value === null)}
                  sitekey={process.env.REACT_APP_RECAPTCHA_KEY}
                />
                <TNCLink />

                <FormRegisterAction disabled={!isFormValid} isLoading={formik.isSubmitting} />

                <ActionLoginSocial onClick={() => {
                  formik.setSubmitting(true)
                }} />

              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Register;
